import api from './api'
const APPOINMENT_URL = "/api/appoinments";
const appoinmentsService = {}

appoinmentsService.updateStatus = async (data) =>{
  try {
    const {id,status} = data
    const res = await api.put(`${APPOINMENT_URL}/update/status/${id}`,{status})
    console.log(res)
    return res.data
  } catch (error) {
    console.log(error)
    throw(error)
  }
}

appoinmentsService.updateAppoinment = async (data) =>{
  try {
    const {id,...body} = data
    const res = await api.put(`${APPOINMENT_URL}/cita/${id}`,body)
    console.log(res)
    return res.data
  } catch (error) {
    console.log(error)
    throw(error)
  }
}



appoinmentsService.createAppoinment = async (data) =>{
  try {
    const res = await api.post(`${APPOINMENT_URL}/create`,data)
    return res.data
  } catch (error) {
    console.log(error)
    throw(error)
  }
}

 appoinmentsService.getAppoinments = async (data) => {
  try {
    const { status = 4, page = 1, busqueda, fechaFin, fechaInicio } = data;

    const res = await api.get(
      `${APPOINMENT_URL}?status=${status}&busqueda=${busqueda}&fechaInicio=${fechaInicio}&fechaFin=${fechaFin}&pagina=${page}`
    );
    return res.data;
  } catch (error) {
    console.log(error)
    throw (error);
  }
};

appoinmentsService.getClients = async (busqueda) => {
  try {

    const res = await api.get(
      `${APPOINMENT_URL}/clients?busqueda=${busqueda}`
    );
    return res.data;
  } catch (error) {
    console.log(error)
    throw (error);
  }
};

appoinmentsService.clienteNuevo = function (cliente) {
  try {
    const res =  api.post('/api/client/create', cliente).then(res => res.data)
    return res
  } catch (err) {
    console.error(err)
    throw(err)
  }
}

export default appoinmentsService
